<auth-page-layout title="Welcome to the {{agency?.name}} Patient Portal"
  [logoUrl]="agency?.logoUrl" cardTitle="Login"
  illustration="assets/illustration-sign-in.png">
  <form>
    <div class="form-group">
      <label for="signin_email">Email address</label>
      <input id="signin_email" name="signin_email" type="email" [(ngModel)]="login.email" class="form-control"
        aria-describedby="emailHelp" placeholder="you@emailprovider.com">
    </div>
    <div class="form-group">
      <label for="signin_password">Password</label>
      <input id="signin_password" name="signin_password" type="password" [(ngModel)]="login.password"
        (keyup.enter)="signIn()" class="form-control" aria-describedby="emailHelp" placeholder="">
    </div>
    <p class="text-right">
      <a routerLink="/auth/reset-request">Forgot password?</a>
    </p>
    <button (click)="signIn()" type="button" class="btn btn-primary btn-block" [disabled]="!login.email || !login.password">Sign In</button>
    <div class="alert alert-danger mt-3" role="alert" *ngIf="login.error">
      {{login.error}}
    </div>
    <small class="form-text text-muted ">Contact {{agency.name}} if you do not yet have an account or if you do
      not know your associated email address.</small>
  </form>
</auth-page-layout>
